/** A compact visible tour button with a 44px-tall pointer target. */
export const compactTourButtonSx = {
  position: 'relative',
  minHeight: 32,
  height: 32,
  py: 0,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  // Keep the visible tour button compact on phones; the pseudo-element
  // provides the larger pointer target.
  '@media (max-width:599.95px)': {
    '&&': { minHeight: 32, height: 32 },
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    // Most stage titles sit just below the navigation. Extend predominantly
    // downward so the touch area does not overlap the stage arrows above.
    top: -2,
    bottom: -10,
    left: 0,
    right: 0,
  },
} as const;
